import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar} from 'react-bootstrap'
import moment from 'moment'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import {humanize} from '../../core/momentz'
import CheckboxToggle from '../../core/components/CheckboxToggle'
import MeasureInput, {timeUnits} from '../../core/components/MeasureInput'
import Icon from '../../core/components/Icon'
import {DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED, sendDefineInterventionTimelimitForInterventionPeriodCmd, updateDefineInterventionTimelimitForInterventionPeriodCmd, sendRemoveInterventionTimelimitFromInterventionPeriodCmd, loadContact} from '../actions'
import {DefineInterventionTimelimitForInterventionPeriodCmd} from '../models'
import i18n from '../i18n'
import style from './DefineRemoveInterventionTimelimitFromInterventionPeriodForm.less'

function openingTicketPurposeLabelAggregator(openingTicketPurposes) {
    return (result, openingTicketPurposeUid) => {
        const openingTicketPurpose = openingTicketPurposes.find((otp) => otp.uid == openingTicketPurposeUid)

        if (openingTicketPurpose) {
            result.push(openingTicketPurpose.label)
        }
        return result
    }
}

function defineCmdUpdate(interventionPeriod) {
    return {
        timelimits: interventionPeriod.interventionTimelimits
    }
}

class DefineRemoveInterventionTimelimitFromInterventionPeriodForm extends Component {
    static propTypes = {
        interventionPeriod: PropTypes.object.isRequired,
        openingTicketPurposes: PropTypes.array.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, interventionPeriod} = this.props

        const update = defineCmdUpdate(interventionPeriod)
        dispatch(updateDefineInterventionTimelimitForInterventionPeriodCmd(update))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.interventionPeriod != this.props.interventionPeriod) {
            const {dispatch, interventionPeriod} = nextProps

            const update = defineCmdUpdate(interventionPeriod)
            dispatch(updateDefineInterventionTimelimitForInterventionPeriodCmd(update))
        }
    }

    _sendDefineCmd() {
        const {dispatch, interventionPeriod, onSubmit} = this.props

        return dispatch(sendDefineInterventionTimelimitForInterventionPeriodCmd(interventionPeriod.uid)).then(() => {
            return dispatch(loadContact())
        }).then(() => {
            onSubmit()
        })
    }

    _sendRemoveCmd() {
        const {dispatch, interventionPeriod, onSubmit} = this.props

        return dispatch(sendRemoveInterventionTimelimitFromInterventionPeriodCmd(interventionPeriod.uid)).then(() => {
            return dispatch(loadContact())
        }).then(() => {
            onSubmit()
        })
    }

    render() {
        const {dispatch, form, cmd, interventionPeriod, openingTicketPurposes, ...others} = this.props

        return (
            <div>
                <ul className={style.interventionTimelimitGroup}>
                    {cmd && cmd.timelimits && cmd.timelimits.slice(1).reverse().map((timelimit, index) => (
                        <li key={index}>
                            <a
                                href=''
                                className={style.remove}
                                onClick={(e) => form.timelimits.remove(e, timelimit)}>
                                <Icon icon='minus' size='xs' />
                            </a>
                            <p>
                                <span>{timelimit.openingTicketPurposes.reduce(openingTicketPurposeLabelAggregator(openingTicketPurposes), []).join(', ')} :</span>
                                <span> {humanize(moment.duration(timelimit.timelimit.value))}</span>
                            </p>
                        </li>
                    ))}
                </ul>
                <form>
                    <MeasureInput
                        name='timelimit'
                        units={timeUnits}
                        placeholder={i18n.interventionTimelimit + ' *'}
                        {...form.timelimits.timelimit.value()}/>
                    <CheckboxToggle
                        {...form.timelimits.openingTicketPurposes()}>
                        {openingTicketPurposes.map((openingTicketPurpose, index) => (
                            <Input
                                key={index}
                                type='checkbox'
                                label={openingTicketPurpose.label}
                                value={openingTicketPurpose.uid} />
                        ))}
                    </CheckboxToggle>
                </form>
                <ButtonToolbar>
                    {form.timelimits.isValid() && (
                        <Button
                            bsStyle='link'
                            onClick={() => form.timelimits.add()}>
                            <Icon icon='plus' size='xs' />
                            <span>{i18n.add}</span>
                        </Button>
                    )}
                    {cmd && cmd.timelimits && cmd.timelimits.length > 1 && (
                        <Button
                            bsStyle='link'
                            onClick={() => form.timelimits.remove()}>
                            <Icon icon='minus' size='xs' />
                            <span>{i18n.remove}</span>
                        </Button>
                    )}
                </ButtonToolbar>
                <ButtonToolbar>
                    <Button
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendDefineCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.validate}
                    </Button>
                    {interventionPeriod.interventionTimelimits.length > 0 && (
                        <Button
                            bsStyle='danger'
                            bsSize='large'
                            onClick={() => this._sendRemoveCmd()}>
                            {i18n.remove}
                        </Button>
                    )}
                </ButtonToolbar>
            </div>
        )
    }
}

DefineRemoveInterventionTimelimitFromInterventionPeriodForm = connectForm({
    target: 'cmd',
    schema: DefineInterventionTimelimitForInterventionPeriodCmd.schema,
    action: DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED
})(DefineRemoveInterventionTimelimitFromInterventionPeriodForm)

DefineRemoveInterventionTimelimitFromInterventionPeriodForm = connect((state) => ({
    cmd: state.provider.defineInterventionTimelimitForInterventionPeriodCmd,
}))(DefineRemoveInterventionTimelimitFromInterventionPeriodForm)

export default DefineRemoveInterventionTimelimitFromInterventionPeriodForm


// WEBPACK FOOTER //
// ./lib/provider/components/DefineRemoveInterventionTimelimitFromInterventionPeriodForm.js